<template>
    <div
        v-if="isVisible"
        @click.stop="handleFrameClick"
        @contextmenu.prevent.stop="handleContextMenu"
        @mousedown.stop="handleMouseDown"
        @mouseup.stop="handleMouseUp"
        @mousemove.stop="handleMouseMove"
        @mouseover.stop="handleMouseOver"
        @mouseleave="handleMouseLeave"
        :style="labelStyle"
        :class="[
            'interactive-labelIcon',
            'interactive-labelNav',
            {
                selected: selected,
            },
        ]"
    >
        <div class="interactive-labelIcon-icon" :style="iconStyle">
            <lucide-icon
                :icon="shape.options.icon.basic.name"
                :size="shape.options.icon.basic.size"
            />
        </div>
        <div
            class="interactive-labelIcon-text"
            :class="{
                'interactive-labelIcon-text--hiddenText':
                    shape.options.text.basic.onHover && !isHover,
            }"
            :style="textStyle"
        >
            <span v-if="shape.translations.content" :style="mainTextStyle">
                {{ contentTranslate }}
            </span>
            <span
                v-if="shape.options.text.basic.subIcon.name"
                :style="subIconStyle"
            >
                <lucide-icon
                    :icon="shape.options.text.basic.subIcon.name"
                    :size="shape.options.text.basic.subIcon.size"
                />
            </span>
            <span v-if="shape.translations.subContent" :style="subTextStyle">
                {{ subContentTranslate }}
            </span>
        </div>
    </div>
</template>

<script>
import { LayerShapeMixin } from "./LayerShapeMixin.js";

export default {
    name: "labelNav",
    mixins: [LayerShapeMixin],

    computed: {
        subContentTranslate() {
            return (
                this.shape.translations.subContent[
                    "langs-" + this.computedLocale
                ] ??
                this.shape.translations.subContent[
                    "langs-" + this.currentLocale
                ] ??
                Object.values(this.shape.translations.subContent)[0]
            );
        },

        labelStyle() {
            const center = this.shape?.center || { x: 0, y: 0 };
            const aspectRatio = this.aspectRatio || 1;

            return {
                top: `${center.y / aspectRatio}px`,
                left: `${center.x / aspectRatio}px`,
                transform: `scale(${this.scale}) translate(-50%, -50%)`,
                transformOrigin: "left top",
            };
        },
        textStyle() {
            const textOptions = this.shape?.options?.text?.basic || {};
            const padding = textOptions.padding || { x: 0, y: 0 };
            const margin = textOptions.margin || { x: 0, y: 0 };
            const position = textOptions.position || "left";
            const stroke = textOptions.stroke || {};

            const currentStyle = this.shape?.options?.text[this.style] || {};
            const strokeColor = currentStyle.stroke?.color || "#000";
            const fillColor = currentStyle.fill?.color || "#fff";
            const textColor = currentStyle.text?.color || "#000";

            let pad = "";

            if (margin.x < 0) {
                if (position === "right") {
                    pad = `${padding.y}px ${padding.x}px ${padding.y}px ${
                        padding.x + Math.abs(margin.x)
                    }px`;
                } else {
                    pad = `${padding.y}px ${padding.x + Math.abs(margin.x)}px ${
                        padding.y
                    }px ${padding.x}px`;
                }
            } else {
                pad = `${padding.y}px ${padding.x}px`;
            }

            return {
                padding: pad,
                fontSize: `${textOptions.text?.size || 14}px`,
                borderRadius: `${stroke.radius || 0}px`,
                margin: `${margin.y}px ${margin.x}px`,
                color: textColor,
                right: position === "right" ? "auto" : "100%",
                left: position === "left" ? "auto" : "100%",
                backgroundColor: fillColor,
                border: `${currentStyle.stroke?.width || 1}px ${
                    stroke.style || "solid"
                } ${strokeColor}`,
            };
        },
        iconStyle() {
            const { options } = this.shape;
            const { icon } = options;
            const { basic } = icon;

            const currentIconStyles = icon[this.style];
            const strokeColor = currentIconStyles.stroke.color;
            const fillColor = currentIconStyles.fill.color;
            const textColor = currentIconStyles.text.color;
            return {
                width: `${basic.diameter}px`,
                height: `${basic.diameter}px`,
                color: `${textColor}`,
                backgroundColor: fillColor,
                borderStyle: `${basic.stroke.style}`,
                borderRadius: `${basic.stroke.radius}px`,
                border: `${currentIconStyles.stroke.width}px ${basic.stroke.style} ${strokeColor}`,
                transform: `rotate(${basic.angle}deg)`,
            };
        },

        subIconStyle() {
            const subIconOptions =
                this.shape?.options?.text?.[this.style]?.subIcon || {};
            const basicText = this.shape?.options?.text?.basic || {};

            return {
                marginRight: `${basicText.gap || 0}px`,
                color: subIconOptions.color || "#000", // Значение по умолчанию, если color не задан
            };
        },

        subTextStyle() {
            const { options } = this.shape;
            const { text } = options;
            const currentStyle = text[this.style];
            const color = currentStyle.subText.color;

            return {
                fontSize: `${text.basic.subText.size}px`,
                color: `${color}`,
            };
        },

        mainTextStyle() {
            const mainTextOptions =
                this.shape?.options?.text?.[this.style]?.text || {};
            const basicText = this.shape?.options?.text?.basic?.text || {};
            const basicGap = this.shape?.options?.text?.basic?.gap || 0;

            return {
                marginRight: `${basicGap}px`,
                fontSize: `${basicText.size || 14}px`, // Значение по умолчанию 14px
                color: mainTextOptions.color || "#000", // Значение по умолчанию, если color не задан
            };
        },
    },

    methods: {},
};
</script>
